'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  account: {
    calendars: 'Calendriers',
    button: {
      remove: 'Supprimer le compte',
      cancel: 'Annuler',
      delete: 'Supprimer'
    },
    chooseLanguage: 'Langue de l’interface',
    english: 'English (Anglais)',
    french: 'Français',
    form: {
      name: 'Nom',
      email: 'Courriel',
      change_password: 'Changer de mot de passe',
      new_password: 'Nouveau mot de passe',
      new_password_confirmation: 'Confirmation du nouveau mot de passe',
      password: 'Mot de passe actuel',
      submit: 'Enregistrer'
    },
    meta_title: 'Compte',
    popover: {
      title: 'Souhaitez-vous vraiment supprimer votre compte Caligram?',
      confirm: 'Supprimer aussi tous les événements dont je suis la seule personne responsable'
    },
    title: 'Compte'
  },
  join: {
    explanation: 'Voulez-vous rejoindre le calendrier "%{name}" ?',
    meta_title: 'Rejoindre un calendrier',
    submit: 'Rejoindre',
    title: 'Rejoindre un calendrier'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr/account.js
// module id = 2290
// module chunks = 0